import { useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import { resolveNavigationFromPath } from "./auth";

const getProfileUserId = (pathname) => {
  const match = pathname.match(/^\/user\/([^/]+)/);
  return match ? match[1] : null;
};

const AutoScrollToTop = () => {
  const location = useLocation();
  const previousPathRef = useRef(location.pathname);

  useEffect(() => {
    const fromPath = resolveNavigationFromPath(location.state?.from);

    // Exempt feed <-> post navigation to preserve scroll position
    if (fromPath.includes("/community") || fromPath.includes("/post")) {
      previousPathRef.current = location.pathname;
      return;
    }

    const previousPath = previousPathRef.current;
    const currentProfileUserId = getProfileUserId(location.pathname);
    const previousProfileUserId = getProfileUserId(previousPath);

    // Switching sidebar tabs on the same profile should not jump to top
    if (
      currentProfileUserId &&
      previousProfileUserId &&
      currentProfileUserId === previousProfileUserId
    ) {
      previousPathRef.current = location.pathname;
      return;
    }

    previousPathRef.current = location.pathname;

    if (location.hash) {
      return;
    }

    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname, location.state, location.hash]);

  return null;
};

export default AutoScrollToTop;
